/**
 * @name                                    main.ts
 * @description                             the main file (entry point)
 * @author                                  Maysara Elshewehy
 * @repo                                    https://github.com/je-es/ansi
 *
 * @note                                    This script follows the `MECS` code style
*/


/* ---------------------------------------- PACK ----------------------------------------  */

    export *                                from './modules/style';
    export *                                from './modules/tools';

/* ---------------------------------------- ---- ----------------------------------------  */